import { RIGHT_WIDTH, TIMELINE_HEADER_HEIGHT } from "../../core/layoutConstants";
import { getTrackGap } from "../../core/functions";
import { ForwardedRef, forwardRef } from "react";
import { TrackTagWrapper } from "../TrackTag/TrackTagWrapper";
import { OccupationsForTrackWithOrder } from "@opstel/SBD/core/occupations";

interface SBDCenterRightProps {
  readonly occupationsForTracks: OccupationsForTrackWithOrder[];
}

function SBDCenterRightWithRef(
  { occupationsForTracks }: SBDCenterRightProps,
  ref: ForwardedRef<HTMLDivElement>,
) {
  return (
    <div
      className="order-3 h-full"
      style={{ paddingTop: `${TIMELINE_HEADER_HEIGHT}px`, width: `${RIGHT_WIDTH}px` }}
    >
      <div
        ref={ref}
        className="flex h-full flex-col items-end overflow-hidden pr-6 *:first:mt-6 *:last:mb-6"
        style={{
          gap: getTrackGap().toString(),
          width: `${RIGHT_WIDTH}px`,
        }}
      >
        {occupationsForTracks.map((occupationsForTrack) => (
          <TrackTagWrapper
            key={occupationsForTrack.track.code}
            occupationsForTrack={occupationsForTrack}
          />
        ))}
      </div>
    </div>
  );
}

export const SBDCenterRight = forwardRef<HTMLDivElement, SBDCenterRightProps>(
  SBDCenterRightWithRef,
);
